import AddBoxIcon from "@mui/icons-material/AddBox";
export const MyConstants = {
  WPATEST: "wpatest",
  YEAR: "Year",
  ACTIVITY_TYPE_OPTIONS: [
    { value: 2, label: "Distance Activity", category: "Mobile Combustion" },
    { value: 3, label: "Fuel Use", category: "Mobile Combustion" },
    {
      value: 4,
      label: "Vehicle Distance",
      category: "Upstream Raw Material Transport Related Emission",
    },
    {
      value: 5,
      label: "Weight Distance",
      category: "Upstream Raw Material Transport Related Emission",
    },
    { value: 6, label: "Distance", category: "Upstream T&D" },
    { value: 7, label: "Passenger Distance", category: "Upstream T&D" },
    { value: 8, label: "Vehicle Distance", category: "Upstream T&D" },
    { value: 9, label: "Weight Distance", category: "Upstream T&D" },
    { value: 10, label: "Distance", category: "Downstream T&D" },
    { value: 11, label: "Passenger Distance", category: "Downstream T&D" },
    { value: 12, label: "Vehicle Distance", category: "Downstream T&D" },
    { value: 13, label: "Weight Distance", category: "Downstream T&D" },
    { value: 14, label: "Distance", category: "Employee Commuting" },
    { value: 15, label: "Passenger Distance", category: "Employee Commuting" },
    { value: 16, label: "Vehicle Distance", category: "Employee Commuting" },
    { value: 17, label: "Weight Distance", category: "Employee Commuting" },
    { value: 18, label: "Distance", category: "Client and Visitor Transport" },
    {
      value: 19,
      label: "Passenger Distance",
      category: "Client and Visitor Transport",
    },
    {
      value: 20,
      label: "Vehicle Distance",
      category: "Client and Visitor Transport",
    },
    {
      value: 21,
      label: "Weight Distance",
      category: "Client and Visitor Transport",
    },
    { value: 22, label: "Distance", category: "Business Travel" },
    { value: 23, label: "Passenger Distance", category: "Business Travel" },
    { value: 24, label: "Vehicle Distance", category: "Business Travel" },
    { value: 25, label: "Weight Distance", category: "Business Travel" },
    {
      value: 26,
      label: "Supplier-specific method",
      category: "Purchased Goods",
      isDisabled: true,
    },
    {
      value: 27,
      label: "Hybrid method",
      category: "Purchased Goods",
      isDisabled: true,
    },
    {
      value: 28,
      label: "Average-data method",
      category: "Purchased Goods",
      isDisabled: false,
    },
    {
      value: 29,
      label: "Spend-based method",
      category: "Purchased Goods",
      isDisabled: true,
    },

    {
      value: 30,
      label: "Cement and lime production",
      category: "Industrial Processes",
    },
    {
      value: 31,
      label: "Chemical production",
      category: "Industrial Processes",
    },
    { value: 32, label: "Manufacturing", category: "Industrial Processes" },
    {
      value: 33,
      label: "Oil and Gas refining",
      category: "Industrial Processes",
    },
    {
      value: 34,
      label: "Non-combustion processes",
      category: "Industrial Processes",
    },
    { value: 35, label: "Others", category: "Industrial Processes" },

    {
      value: 36,
      label: "Forest land",
      category: "Land Use, Land Use Change and Forestry (LULUCF)",
    },
    {
      value: 37,
      label: "Cropland",
      category: "Land Use, Land Use Change and Forestry (LULUCF)",
    },
    {
      value: 38,
      label: "Grassland",
      category: "Land Use, Land Use Change and Forestry (LULUCF)",
    },
    {
      value: 39,
      label: "Wetland",
      category: "Land Use, Land Use Change and Forestry (LULUCF)",
    },
    {
      value: 40,
      label: "Settlement",
      category: "Land Use, Land Use Change and Forestry (LULUCF)",
    },
    {
      value: 41,
      label: "Other land",
      category: "Land Use, Land Use Change and Forestry (LULUCF)",
    },
    { value: 30, label: "Asset-specific method", category: "Use Of Assets" },
    { value: 31, label: "Lessor-specific method", category: "Use Of Assets" },
    { value: 32, label: "Average-data method", category: "Use Of Assets" },
  ],
  CUSTOM_CALCULATE_TYPE_OPTIONS: [
    {
      value: 1,
      label: "Asset-specific method",
      category: "Use of Assets (through leased equipment) by an Organization",
      key: "Supplier-specific",
      isDisabled: false,
    },
    {
      value: 2,
      label: "Lessor-specific method",
      category: "Use of Assets (through leased equipment) by an Organization",
      key: "Lessor-specific method",
      isDisabled: true,
    },
    {
      value: 3,
      label: "Average-data method",
      category: "Use of Assets (through leased equipment) by an Organization",
      key: "Average-data method",
      isDisabled: true,
    },
    {
      value: 4,
      label: "Supplier-specific",
      category:
        "Capital Goods that are Purchased and Amortized by an Organization",
      key: "Supplier-specific",
      isDisabled: false,
    },
    {
      value: 5,
      label: "Supplier-specific",
      category:
        "Use of Services not Described in the above sub-categories by an Organization",
      key: "Supplier-specific",
      isDisabled: false,
    },
    {
      value: 6,
      label: "Supplier-specific",
      category: "Use Stage of the Product",
      key: "Supplier-specific",
      isDisabled: false,
    },
    {
      value: 7,
      label: "Supplier-specific",
      category: "Downstream Leased Assets",
      key: "Supplier-specific",
      isDisabled: false,
    },
    {
      value: 8,
      label: "Supplier-specific",
      category: "End of Life Stage of the Product",
      key: "Supplier-specific",
      isDisabled: false,
    },
    {
      value: 9,
      label: "Supplier-specific",
      category: "Investments",
      key: "Supplier-specific",
      isDisabled: false,
    },
    {
      value: 10,
      label: "Supplier-specific",
      category: "GHG Emissions or Removals from Other Sources",
      key: "Supplier-specific",
      isDisabled: false,
    },
    {
      value: 11,
      label: "Supplier-specific",
      category: "Land Use, Land Use Change and Forestry (LULUCF)",
      key: "Supplier-specific",
      isDisabled: false,
    },
    {
      value: 12,
      label: "Average-data method",
      category: "End of Life Stage of the Product",
      key: "Average-data method",
      isDisabled: false,
    },
  ],
  EMISSION_SOURCE_OPTIONS: [
    {
      value: 1,
      label: "Decrease in carbon stock (emission)",
      category: "Land Use, Land Use Change and Forestry (LULUCF)",
      key: "Decrease in carbon stock (emission)",
      isDisabled: false,
    },
    {
      value: 2,
      label: "Increase in carbon stock (removal)",
      category: "Land Use, Land Use Change and Forestry (LULUCF)",
      key: "Increase in carbon stock (removal)",
      isDisabled: true,
    },
  ],
  YEAR_OPTIONS: [
    { value: 2018, label: "2018" },
    { value: 2019, label: "2019" },
    { value: 2020, label: "2020" },
    { value: 2021, label: "2021" },
    { value: 2022, label: "2022" },
  ],
  VEHICLE_TYPE_OPTIONS: [
    { value: 1, label: "Gasoline Passenger Cars", fuelType: "Motor Gasoline" },
    {
      value: 2,
      label: "Gasoline Light-duty Trucks (Vans, Pickup Trucks, SUVs)",
      fuelType: "Motor Gasoline",
    },
    {
      value: 3,
      label: "Gasoline Heavy-duty Vehicles",
      fuelType: "Motor Gasoline",
    },
    {
      value: 4,
      label: "Hybrid (Gasoline) Passenger Cars",
      fuelType: "Motor Gasoline",
    },
    {
      value: 5,
      label: "Gasoline Agricultural Equipment",
      fuelType: "Motor Gasoline",
    },
    { value: 6, label: "Gasoline Ships and Boats", fuelType: "Motor Gasoline" },
    { value: 7, label: "Gasoline Motorcycles", fuelType: "Motor Gasoline" },
    {
      value: 8,
      label: "Other Gasoline Non-Road Vehicles",
      fuelType: "Motor Gasoline",
    },
    { value: 9, label: "Diesel Passenger Cars", fuelType: "Diesel Fuel" },
    { value: 10, label: "Diesel Light-duty Trucks", fuelType: "Diesel Fuel" },
    {
      value: 11,
      label: "Diesel Medium- and Heavy-duty Vehicles",
      fuelType: "Diesel Fuel",
    },
    {
      value: 12,
      label: "Diesel Agricultural Equipment",
      fuelType: "Diesel Fuel",
    },
    { value: 13, label: "Diesel Ships and Boats", fuelType: "Diesel Fuel" },
    {
      value: 14,
      label: "Heavy-duty Vehicles",
      fuelType: "Ethanol (100%) - Ethanol Medium",
    },
    {
      value: 15,
      label: "Other Diesel Non-Road Vehicles",
      fuelType: "Diesel Fuel",
    },
    {
      value: 16,
      label: "Biodiesel Passenger Cars",
      fuelType: "Biodiesel (100%)",
    },
    {
      value: 17,
      label: "Biodiesel Light-duty Vehicles",
      fuelType: "Biodiesel (100%)",
    },
    {
      value: 18,
      label: "Biodiesel Medium- and Heavy-duty Vehicles",
      fuelType: "Biodiesel (100%)",
    },
    {
      value: 19,
      label: "CNG Light-duty Vehicles",
      fuelType: "Compressed Natural Gas",
    },
    {
      value: 20,
      label: "CNG Medium- and Heavy-duty Vehicles",
      fuelType: "Compressed Natural Gas",
    },
    {
      value: 21,
      label: "Ethanol Light-duty Vehicles",
      fuelType: "Ethanol (100%)",
    },
    {
      value: 22,
      label: "Ethanol Medium- and Heavy-duty Vehicles",
      fuelType: "Ethanol (100%)",
    },
    { value: 23, label: "Jet Fuel Aircraft", fuelType: "Jet Fuel" },
    {
      value: 24,
      label: "Aviation Gasoline Aircraft",
      fuelType: "Aviation Gasoline",
    },
    { value: 25, label: "General", fuelType: "Diesel oil" },
    { value: 27, label: "Electric Vehicle", fuelType: "Electricity - Mobile" },
    {
      value: 28,
      label: "CNG Light-duty Vehicles",
      fuelType: "Compressed Natural Gas - CNG Medium",
    },
    {
      value: 29,
      label: "Heavy-duty Vehicles",
      fuelType: "Biodiesel (100%) - Biodiesel Medium",
    },
    {
      value: 30,
      label: "Heavy-duty Vehicles",
      fuelType: "Diesel Fuel - Diesel Medium",
    },
    { value: 31, label: "Electric Vehicle", fuelType: "Electricity" },
    { value: 32, label: "Electric gen", fuelType: "Gasohol" },
    { value: 33, label: "Lawn mower", fuelType: "Gasohol" },
    { value: 34, label: "Mobile pump", fuelType: "Gasohol" },
    { value: 35, label: "Non-road vehicle", fuelType: "Gas LPG" },
    { value: 26, label: "Agriculture - mobile machinery", fuelType: "Petrol" },
    { value: 36, label: "House and garden machinery", fuelType: "Petrol" },
    {
      value: 37,
      label: "Industrial off-road mobile machinery",
      fuelType: "Petrol",
    },
    {
      value: 38,
      label: "Road transport - cars - rural driving",
      fuelType: "Petrol",
    },
    {
      value: 39,
      label: "Road transport - LGVs - rural driving",
      fuelType: "Petrol",
    },
    {
      value: 40,
      label: "Road transport - motorcycle (>50cc  4st) - rural driving",
      fuelType: "Petrol",
    },
    {
      value: 41,
      label: "Road transport - cars - urban driving",
      fuelType: "Petrol",
    },
    {
      value: 42,
      label: "Road transport - LGVs - urban driving",
      fuelType: "Petrol",
    },
    {
      value: 43,
      label: "Road transport - mopeds (<50cc 2st) - urban driving",
      fuelType: "Petrol",
    },
    {
      value: 44,
      label: "Road transport - motorcycle (>50cc  2st) - urban driving",
      fuelType: "Petrol",
    },
    {
      value: 45,
      label: "Road transport - motorcycle (>50cc  4st) - urban driving",
      fuelType: "Petrol",
    },
    {
      value: 46,
      label: "Road transport - cars - motorway driving",
      fuelType: "Petrol",
    },
    {
      value: 47,
      label: "Road transport - LGVs - motorway driving",
      fuelType: "Petrol",
    },
    {
      value: 48,
      label: "Road transport - motorcycle (>50cc  4st) - motorway driving",
      fuelType: "Petrol",
    },
    { value: 49, label: "RMotorboats / workboats", fuelType: "Petrol" },
    { value: 50, label: "Personal watercraft", fuelType: "Petrol" },
  ],
  EMISSION_FACTOR_OPTIONS: [
    {
      value: 1,
      label: "Location Based",
      category: "Purchased Electricity",
      key: "Grid Average / Location Based",
    },
    {
      value: 2,
      label: "Grid Average / Location Based",
      category: "Imported energy (steam, heating, cooling and compressed air)",
    },
    {
      value: 3,
      label: "Custom",
      category: "Purchased Electricity",
      key: "Custom",
    },
    { value: 4, label: "Plastic (PS)", category: "Purchased Goods" },
    { value: 5, label: "Plastic (ABS)", category: "Purchased Goods" },
    { value: 6, label: "PET (film)", category: "Purchased Goods" },
    { value: 7, label: "Aluminium", category: "Purchased Goods" },
    { value: 8, label: "Steel", category: "Purchased Goods" },
    { value: 9, label: "Cyclohexane", category: "Purchased Goods" },
    { value: 10, label: "Epoxyresin", category: "Purchased Goods" },
    { value: 11, label: "Copper", category: "Purchased Goods" },
    { value: 12, label: "Glass", category: "Purchased Goods" },
    {
      value: 13,
      label: "Supplier-specific (Location Based)",
      category: "Imported Energy",
      key: "Location Based",
      isDisabled: false,
    },
    {
      value: 14,
      label: "Fuel-based",
      category: "Imported Energy",
      key: "Fuel-based",
    },
    { value: 21, label: "Cement", category: "Purchased Goods" },
    { value: 22, label: "Plaster", category: "Purchased Goods" },
    { value: 23, label: "Paint", category: "Purchased Goods" },
    { value: 24, label: "Timber", category: "Purchased Goods" },
    { value: 25, label: "Concrete", category: "Purchased Goods" },
    { value: 26, label: "Electricity", category: "Purchased Goods" },
    { value: 27, label: "Natural Gas", category: "Purchased Goods" },
    { value: 28, label: "Cotton", category: "Purchased Goods" },
    { value: 29, label: "Polymer", category: "Purchased Goods" },
    { value: 30, label: "Waste sent to landfill", category: "Purchased Goods" },
    { value: 31, label: "T-shirts", category: "Purchased Goods" },
    { value: 32, label: "Hard Drive", category: "Purchased Goods" },
    { value: 33, label: "Integrated Circuits", category: "Purchased Goods" },
    {
      value: 34,
      label: "Liquid Crystal Display(LCD)",
      category: "Purchased Goods",
    },
    { value: 35, label: "Semiconductors", category: "Purchased Goods" },
    { value: 36, label: "Battery", category: "Purchased Goods" },
    { value: 37, label: "Keyboard", category: "Purchased Goods" },
    { value: 38, label: "Laptops", category: "Purchased Goods" },
    { value: 39, label: "Lights/fixtures", category: "Purchased Goods" },
    { value: 40, label: "IT Hardware", category: "Purchased Goods" },
    {
      value: 41,
      label: "Custom",
      category: "Emission Removal & Mitigation",
      key: "Custom",
      isDisabled: true,
    },
    {
      value: 42,
      label: "Location Based",
      category: "Emission Removal & Mitigation",
      key: "Grid Average / Location Based",
      isDisabled: false,
    },
  ],
  FUGITIVE_EMISSIONS_METHOD_OPTIONS: [
    {
      value: 1,
      label: "Actual Filling Amount",
      category: "Refrigerants and Fugitives",
    },
    {
      value: 2,
      label: "Original Filling Amount",
      category: "Refrigerants and Fugitives",
    },
    { value: 3, label: "Septic Tank", category: "Refrigerants and Fugitives" },
  ],
  ORIGINAL_FILLING_AMOUNT: [
    {
      value: "Domestic Refrigeration - 0.3",
      amount: 0.3,
      label: "Domestic Refrigeration - 0.3",
      category: "Refrigerants and Fugitives",
    },
    {
      value: "Stand-alone Commercial Applications - 5.5",
      amount: 5.5,
      label: "Stand-alone Commercial Applications - 5.5",
      category: "Refrigerants and Fugitives",
    },
    {
      value: "Medium & Large Commercial Refrigeration - 20",
      amount: 20,
      label: "Medium & Large Commercial Refrigeration - 20",
      category: "Refrigerants and Fugitives",
    },
    {
      value: "Transport Refrigeration - 33",
      amount: 33,
      label: "Transport Refrigeration - 33",
      category: "Refrigerants and Fugitives",
    },
    {
      value:
        "Industrial Refrigeration including Food Processing and Cold Storage - 16",
      amount: 16,
      label:
        "Industrial Refrigeration including Food Processing and Cold Storage - 16",
      category: "Refrigerants and Fugitives",
    },
    {
      value: "Chillers - 9",
      amount: 9,
      label: "Chillers - 9",
      category: "Refrigerants and Fugitives",
    },
    {
      value: "Residential and Commercial A/C, including Heat Pumps - 3",
      amount: 3,
      label: "Residential and Commercial A/C, including Heat Pumps - 3",
      category: "Refrigerants and Fugitives",
    },
    {
      value: "Mobile A/C - 20",
      amount: 20,
      label: "Mobile A/C - 20",
      category: "Refrigerants and Fugitives",
    },
  ],
  DEVICE_TYPE_OPTIONS: [
    { value: 1, label: "Generator", category: "Stationary Combustion" },
    { value: 2, label: "Boiler", category: "Stationary Combustion" },
    { value: 3, label: "Convector", category: "Stationary Combustion" },
    { value: 4, label: "Kiln", category: "Stationary Combustion" },
    { value: 5, label: "Dryer", category: "Stationary Combustion" },
    { value: 6, label: "Backup generator", category: "Stationary Combustion" },
    {
      value: 7,
      label: "Combustion Turbine",
      category: "Stationary Combustion",
    },
    { value: 8, label: "Gas Stove", category: "Stationary Combustion" },
    {
      value: 9,
      label: "Pulverized-coal fired boiler",
      category: "Stationary Combustion",
    },
    { value: 10, label: "Incinerator", category: "Stationary Combustion" },
    { value: 11, label: "Flare Tower", category: "Stationary Combustion" },
    {
      value: 12,
      label: "Regenerative Thermal Oxidizer (RTO)",
      category: "Stationary Combustion",
    },
    // { value: 13, label: "Chillers", category: "Stationary Combustion" },
    {
      value: 14,
      label: "Stand-alone Commercial Applications",
      category: "Refrigerants and Fugitives",
    },
    { value: 15, label: "GCB/GIS", category: "Stationary Combustion" },
    { value: 16, label: "Chillers", category: "Fugitive Emission" },
    {
      value: 17,
      label: "Domestic Refrigeration",
      category: "Fugitive Emission",
    },
    {
      value: 18,
      label: "Medium & large Commericial Refrigeration",
      category: "Fugitive Emission",
    },
    {
      value: 19,
      label: "Mobile Air Conditioning",
      category: "Fugitive Emission",
    },
    {
      value: 20,
      label: "Residential & Commercial",
      category: "Fugitive Emission",
    },
    {
      value: 21,
      label: "Standalone Commercial Application",
      category: "Fugitive Emission",
    },
    {
      value: 22,
      label: "Transport Refrigeration",
      category: "Fugitive Emission",
    },
    { value: 23, label: "Including Heat Pumps", category: "Fugitive Emission" },
    {
      value: 24,
      label:
        "Industrial Refrigeration Including Food Processing and Cold Storage",
      category: "Fugitive Emission",
    },
    {
      value: 25,
      label: "Medium & Large Commercial Refrigeration",
      category: "Refrigerants and Fugitives",
    },
    {
      value: 26,
      label: "Transport Refrigeration",
      category: "Refrigerants and Fugitives",
    },
    {
      value: 27,
      label:
        "Industrial Refrigeration including Food Processing and Cold Storage",
      category: "Refrigerants and Fugitives",
    },
    { value: 28, label: "Chillers", category: "Refrigerants and Fugitives" },
    {
      value: 29,
      label: "Residential and Commercial",
      category: "Refrigerants and Fugitives",
    },
    {
      value: 30,
      label: "Including Heat Pumps",
      category: "Refrigerants and Fugitives",
    },
    {
      value: 31,
      label: "Mobile Air Conditioning",
      category: "Refrigerants and Fugitives",
    },
    {
      value: 32,
      label: "Domestic Refrigeration",
      category: "Refrigerants and Fugitives",
    },
    {
      value: 33,
      label: "Onshore Petroleum & Natural Gas Production",
      category: "Refrigerants and Fugitives",
    },
    {
      value: 34,
      label: "WD-40",
      category: "Refrigerants and Fugitives",
    },
    { value: 35, label: "Others", category: "Stationary Combustion" },
    { value: 36, label: "Septic Tank", category: "Refrigerants and Fugitives" },
    {
      value: 37,
      label: "Fire Extinguisher",
      category: "Refrigerants and Fugitives",
    },

    { value: 38, label: "Power upstream", category: "Purchased Goods" },
    { value: 39, label: "Gasoline upstream", category: "Purchased Goods" },
    { value: 40, label: "Diesel upstream", category: "Purchased Goods" },
    { value: 41, label: "Raw materials", category: "Purchased Goods" },
    { value: 42, label: "Chemicals", category: "Purchased Goods" },
    { value: 43, label: "Oil products", category: "Purchased Goods" },
    { value: 44, label: "Packaging materials", category: "Purchased Goods" },
  ],
  CALCULATION_APPROACH_OPTIONS: [
    {
      value: 1,
      label: "Purchased Electricity",
      key: "Purchased Electricity(Location Based)",
      category: "Purchased Electricity",
    },
    {
      value: 2,
      label: "Purchased Steam/Heat",
      key: "Purchased Steam/Heat",
      category: "Imported Energy",
    },
    {
      value: 3,
      label: "Purchased Cooling",
      key: "Purchased Cooling",
      category: "Imported Energy",
    },
    {
      value: 4,
      label: "Purchased Compressed Air",
      key: "Purchased Compressed Air",
      category: "Imported Energy",
    },
    {
      value: 5,
      label: "Others",
      key: "Others",
      category: "Imported Energy",
    },
  ],
  TRANSPORT_MODE_OPTIONS: [
    { value: 1, label: "Air", category: "Upstream T&D" },
    { value: 2, label: "Bus", category: "Upstream T&D" },
    { value: 3, label: "Car", category: "Upstream T&D" },
    { value: 4, label: "Ferry", category: "Upstream T&D" },
    { value: 5, label: "Rail", category: "Upstream T&D" },
    { value: 6, label: "Ship", category: "Upstream T&D" },
    { value: 7, label: "Motorcycle", category: "Upstream T&D" },
  ],
  CALCULATE_TYPE_OPTIONS: [
    { value: 1, label: "Location Based", category: "Purchased Electricity" },
    { value: 2, label: "Market Based", category: "Purchased Electricity" },
    { value: 3, label: "Steam and Heat", category: "Purchased Electricity" },
  ],
  UNIT_OPTIONS: [
    { value: 1, label: "Liter", activityType: "all" },
    { value: 2, label: "gal (US)", activityType: "all" },
    { value: 3, label: "gal (US)", activityType: "Fuel Use" },
    { value: 4, label: "Liter", activityType: "Fuel Use" },
    { value: 5, label: "bbl", activityType: "Fuel Use" },
    { value: 6, label: "scf", activityType: "Fuel Use" },
    { value: 7, label: "ccf", activityType: "Fuel Use" },
    { value: 8, label: "m³", activityType: "Fuel Use" },
    { value: 9, label: "nautical mile", activityType: "Distance Activity" },
    { value: 10, label: "mile", activityType: "Distance Activity" },
    { value: 11, label: "km", activityType: "Distance Activity" },
    { value: 12, label: "kWh", activityType: "scope2" },
    { value: 13, label: "mile", activityType: "Upstream T&D" },
    { value: 14, label: "km", activityType: "Upstream T&D" },
    { value: 15, label: "passenger-mile", activityType: "Upstream T&D" },
    { value: 16, label: "passenger-km", activityType: "Upstream T&D" },
    { value: 17, label: "kWh", activityType: "Fuel Use" },
    { value: 18, label: "Btu", activityType: "Stationary Combustion" },
    { value: 19, label: "mmBtu", activityType: "Stationary Combustion" },
    { value: 20, label: "kg", activityType: "Refrigerants and Fugitives" },
    { value: 21, label: "therm", activityType: "Stationary Combustion" },
    { value: 22, label: "kg", activityType: "Waste" },
    { value: 23, label: "kWh", activityType: "Stationary Combustion" },
    { value: 24, label: "MWh", activityType: "Stationary Combustion" },
    { value: 25, label: "MJ", activityType: "Stationary Combustion" },
    { value: 26, label: "GJ", activityType: "Stationary Combustion" },
    { value: 27, label: "Liter", activityType: "Stationary Combustion" },
    { value: 28, label: "kg", activityType: "Purchased Goods" },
    { value: 29, label: "kg", activityType: "Emission Removal & Mitigation" },
    { value: 30, label: "CuM", activityType: "Water" },
    { value: 31, label: "ton", activityType: "Stationary Combustion" },
    { value: 32, label: "N.m³", activityType: "Stationary Combustion" },
    { value: 33, label: "ton", activityType: "Electric gen" },
    { value: 34, label: "ton", activityType: "Lawn mower" },
    { value: 34, label: "kg", activityType: "Non-road vehicle" },
  ],
  CARBON_ACCOUNT_ROLES: [
    { label: "Reseller", value: "reseller" },
    { label: "Super Admin", value: "super_admin" },
    { label: "Admin", value: "admin" },
    { label: "Operator", value: "operator" },
    { label: "Viewer", value: "viewer" },
    { label: "System Admin", value: "system_admin" },
    { label: "Auditor", value: "auditor" },
    // { label: "Viewer", value: "viewer"},
    { label: "Custom Validator", value: "custom_validator" },
    { label: "Translator", value: "translator" },
  ],
  CARBON_ACCOUNT_SUB_ROLES: [
    { label: "Admin", value: "admin" },
    { label: "Operator", value: "operator" },
    { label: "Viewer", value: "viewer" },
  ],
  CARBON_ROLES_FOR_ORG: [{ label: "Viewer", value: "viewer" }],
  CARBON_ROLES_FOR_SUP: [
    { label: "Super Admin", value: "super_admin" },
    { label: "Admin", value: "admin" },
    { label: "Operator", value: "operator" },
    { label: "Viewer", value: "viewer" },
    { label: "Custom Validator", value: "custom_validator" },
  ],
  RESELLER: "reseller",
  SYSTEM_ADMIN: "system_admin",
  Org_Admin: "org_admin",
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  OPERATOR: "operator",
  VIEWER: "viewer",
  AUDITOR: "auditor",
  REQUESTER: "Requester",
  CUSTOM_VALIDATOR: "custom_validator",
  TRANSLATOR: "translator",
  EMISSIONS: [
    {
      label: "Scope 1 | Category 1",
      value: "Scope 1 | Category 1",
      scope: "1",
      category: [
        {
          key: "Stationary Combustion",
          label: "1.1 Stationary Combustion",
          isDisabled: false,
        },
        {
          key: "Mobile Combustion",
          label: "1.2 Mobile Combustion",
          isDisabled: false,
        },
        {
          key: "Industrial Processes",
          label: "1.3 Industrial Processes",
          isDisabled: false,
        },
        {
          key: "Refrigerants and Fugitives",
          label: "1.4 Fugitive Emissions",
          isDisabled: false,
        },
        {
          key: "Land Use, Land Use Change and Forestry (LULUCF)",
          label: "1.5 Land Use, Land Use Change and Forestry (LULUCF)",
          isDisabled: true,
        },
      ],
    },
    {
      label: "Scope 2 | Category 2",
      value: "Scope 2 | Category 2",
      scope: "2",
      category: [
        {
          key: "Purchased Electricity",
          label: "2.1 Imported Electricity",
          isDisabled: false,
        },
        {
          key: "Imported Energy",
          label: "2.2 Imported Energy",
          isDisabled: true,
        },
      ],
    },
    {
      label: "Scope 3 | Category 3",
      value: "Scope 3 | Category 3",
      scope: "3",
      category: [
        {
          key: "Upstream T&D",
          label: "3.1 Upstream Transport and Distribution for Goods",
          isDisabled: false,
        },
        {
          key: "Downstream T&D",
          label: "3.2 Downstream Transport and Distribution for Goods",
          isDisabled: false,
        },
        {
          key: "Employee Commuting",
          label: "3.3 Employee Commuting",
          isDisabled: false,
        },
        {
          key: "Client and Visitor Transport",
          label: "3.4 Client and Visitor Transport",
          isDisabled: false,
        },
        {
          key: "Business Travel",
          label: "3.5 Business Travel",
          isDisabled: false,
        },
      ],
    },
    {
      label: "Scope 3 | Category 4",
      value: "Scope 3 | Category 4",
      scope: "3",
      category: [
        {
          key: "Purchased Goods",
          label: "4.1 Goods Purchased by an Organization",
          isDisabled: false,
        },
        {
          key: "Capital Goods that are Purchased and Amortized by an Organization",
          label:
            "4.2 Capital Goods that are Purchased and Amortized by an Organization",
          isDisabled: true,
        },
        {
          key: "Waste",
          label:
            "4.3 Disposal Services (of solid or liquid waste) Used by an Organization",
          isDisabled: false,
        },
        {
          key: "Use of Assets (through leased equipment) by an Organization",
          label:
            "4.4 Use of Assets (through leased equipment) by an Organization",
          isDisabled: true,
        },
        {
          key: "Use of Services not Described in the above sub-categories by an Organization",
          label:
            "4.5 Use of Services not Described in the above sub-categories by an Organization",
          isDisabled: true,
        },
      ],
    },
    {
      label: "Scope 3 | Category 5",
      value: "Scope 3 | Category 5",
      scope: "3",
      category: [
        {
          key: "Use Stage of the Product",
          label: "5.1 Use Stage of the Product",
          isDisabled: true,
        },
        {
          key: "Downstream Leased Assets",
          label: "5.2 Downstream Leased Assets",
          isDisabled: true,
        },
        {
          key: "End of Life Stage of the Product",
          label: "5.3 End of Life Stage of the Product",
          isDisabled: true,
        },
        { key: "Investments", label: "5.4 Investments", isDisabled: true },
      ],
    },
    {
      label: "Scope 3 | Category 6",
      value: "Scope 3 | Category 6",
      scope: "3",
      category: [
        {
          key: "Indirect GHG Emissions from other sources",
          label: "6.1 Indirect GHG Emissions from other sources",
          isDisabled: true,
        },
      ],
    },
    {
      label: "CO₂ Emission From Biomass/Bioenergy",
      value: "CO₂ Emission From Biomass/Bioenergy",
      scope: "biomass",
      category: [
        {
          key: "Stationary Combustion",
          label: "1.1 Stationary Combustion",
          isDisabled: true,
        },
        {
          key: "Mobile Combustion",
          label: "1.2 Mobile Combustion",
          isDisabled: true,
        },
        {
          key: "Upstream Transport and Distribution for Goods",
          label: "3.1 Upstream Transport and Distribution for Goods",
          isDisabled: true,
        },
        {
          key: "Downstream Transport and Distribution for Goods",
          label: "3.2 Downstream Transport and Distribution for Goods",
          isDisabled: true,
        },
      ],
    },
  ],
  AUDITOR_EMISSIONS: [
    {
      value: "All",
      scope: 1,
      label: "Select All Categories",
      isDisabled: false,
    },
    {
      value: "Stationary Combustion",
      scope: 1,
      label: "1.1 Stationary Combustion",
      Units: [
        "GJ",
        "Btu",
        "mmBtu",
        "therm",
        "kWh",
        "MWh",
        "MJ",
        "kg",
        "lbs",
        "g",
        "short tons",
        "tonne",
        "gal (US)",
        "Liter",
        "bbl",
        "scf",
        "ccf",
        "m3",
        "km",
        "nauticalmile",
        "mile",
        "Hphr",
        "MMcf gas to flare",
        "rig engine",
        "ha",
        "ha/yr",
        "head/yr",
      ],
      isDisabled: false,
    },
    {
      value: "Mobile Combustion",
      scope: 1,
      label: "1.2 Mobile Combustion",
      Units: [
        "GJ",
        "Btu",
        "mmBtu",
        "therm",
        "kWh",
        "MWh",
        "MJ",
        "kg",
        "lbs",
        "g",
        "short tons",
        "tonne",
        "gal (US)",
        "Liter",
        "bbl",
        "scf",
        "ccf",
        "m3",
        "km",
        "nauticalmile",
        "mile",
        "miles",
        "Hphr",
        "MMcf gas to flare",
        "rig engine",
        "ha",
        "ha/yr",
        "head/yr",
      ],
      isDisabled: false,
    },
    {
      value: "Industrial Processes",
      scope: 1,
      label: "1.3 Industrial Processes",
      Units: [
        "GJ",
        "Btu",
        "mmBtu",
        "therm",
        "kWh",
        "MWh",
        "MJ",
        "kg",
        "lbs",
        "g",
        "short tons",
        "tonne",
        "gal (US)",
        "Liter",
        "bbl",
        "scf",
        "ccf",
        "m3",
        "km",
        "nauticalmile",
        "mile",
        "Hphr",
        "MMcf gas to flare",
        "rig engine",
        "ha",
        "ha/yr",
        "ha/year",
        "head/yr",
      ],
      isDisabled: false,
    },
    {
      value: "Refrigerants and Fugitives",
      scope: 1,
      label: "1.4 Fugitive Emissions",
      Units: [
        "GJ",
        "Btu",
        "mmBtu",
        "therm",
        "kWh",
        "MWh",
        "MJ",
        "kg",
        "lbs",
        "g",
        "short tons",
        "tonne",
        "gal (US)",
        "Liter",
        "bbl",
        "scf",
        "ccf",
        "m3",
        "km",
        "nauticalmile",
        "mile",
        "Hphr",
        "MMcf gas to flare",
        "rig engine",
        "ha",
        "ha/yr",
        "head/yr",
      ],
      isDisabled: false,
    },
    {
      value: "Land Use, Land Use Change and Forestry (LULUCF)",
      scope: 1,
      label: "1.5 Land Use, Land Use Change and Forestry (LULUCF)",
      Units: [
        "GJ",
        "Btu",
        "mmBtu",
        "therm",
        "kWh",
        "MWh",
        "MJ",
        "kg",
        "lbs",
        "g",
        "short tons",
        "tonne",
        "gal (US)",
        "Liter",
        "bbl",
        "scf",
        "ccf",
        "m3",
        "km",
        "nauticalmile",
        "mile",
        "Hphr",
        "MMcf gas to flare",
        "rig engine",
        "ha",
        "ha/yr",
        "head/yr",
      ],
      isDisabled: false,
    },
    {
      value: "All",
      scope: 2,
      label: "Select All Categories",
      isDisabled: false,
    },
    {
      value: "Purchased Electricity",
      scope: 2,
      label: "2.1 Imported Electricity",
      Units: [
        "GJ",
        "Btu",
        "mmBtu",
        "therm",
        "kWh",
        "MWh",
        "MJ",
        "kg",
        "lbs",
        "g",
        "short tons",
        "tonne",
        "gal (US)",
        "Liter",
        "bbl",
        "scf",
        "ccf",
        "m3",
      ],
      isDisabled: false,
    },
    {
      value: "Imported Energy",
      scope: 2,
      label: "2.2 Imported Energy",
      Units: [
        "GJ",
        "Btu",
        "mmBtu",
        "therm",
        "kWh",
        "MWh",
        "MJ",
        "kg",
        "lbs",
        "g",
        "short tons",
        "tonne",
        "gal (US)",
        "Liter",
        "bbl",
        "scf",
        "ccf",
        "m3",
      ],
      isDisabled: false,
    },
    {
      value: "All",
      scope: 3,
      label: "Select All Categories",
      isDisabled: false,
    },
    {
      value: "Upstream T&D",
      scope: 3,
      label: "3.1 Upstream Transport and Distribution for Goods",
      Units: [
        "km",
        "nautical mile",
        "mile",
        "tonne-km",
        "ton-mile",
        "vehicle-mile",
        "vehicle-km",
        "passenger-mile",
        "passenger-km",
      ],
      isDisabled: false,
    },
    {
      value: "Downstream T&D",
      scope: 3,
      label: "3.2 Downstream Transport and Distribution for Goods",
      Units: [
        "km",
        "nautical mile",
        "mile",
        "tonne-km",
        "ton-mile",
        "vehicle-mile",
        "vehicle-km",
        "passenger-mile",
        "passenger-km",
      ],
      isDisabled: false,
    },
    {
      value: "Employee Commuting",
      scope: 3,
      label: "3.3 Employee Commuting",
      Units: [
        "km",
        "nautical mile",
        "mile",
        "tonne-km",
        "ton-mile",
        "vehicle-mile",
        "vehicle-km",
        "passenger-mile",
        "passenger-km",
      ],
      isDisabled: false,
    },
    {
      value: "Client and Visitor Transport",
      scope: 3,
      label: "3.4 Client and Visitor Transport",
      Units: [
        "km",
        "nautical mile",
        "mile",
        "tonne-km",
        "ton-mile",
        "vehicle-mile",
        "vehicle-km",
        "passenger-mile",
        "passenger-km",
      ],
      isDisabled: false,
    },
    {
      value: "Business Travel",
      scope: 3,
      label: "3.5 Business Travel",
      Units: [
        "km",
        "nautical mile",
        "mile",
        "tonne-km",
        "ton-mile",
        "vehicle-mile",
        "vehicle-km",
        "passenger-mile",
        "passenger-km",
      ],
      isDisabled: false,
    },
    {
      value: "Purchased Goods",
      scope: 3,
      label: "4.1 Goods Purchased by an Organization",
      Units: [
        "kg",
        "lbs",
        "g",
        "short tons",
        "tonne",
        "2021 USD_ purchaser price",
        "2021 SGD_ purchaser price",
        "2021 THB_ purchaser price",
        "2021 TWD_ purchaser price",
        "2021 JPY_ purchaser price",
      ],
      isDisabled: false,
    },
    {
      value:
        "Capital Goods that are Purchased and Amortized by an Organization",
      scope: 3,
      label:
        "4.2 Capital Goods that are Purchased and Amortized by an Organization",
      Units: [
        "kg",
        "lbs",
        "g",
        "short tons",
        "tonne",
        "2021 USD_ purchaser price",
        "2021 SGD_ purchaser price",
        "2021 THB_ purchaser price",
        "2021 TWD_ purchaser price",
        "2021 JPY_ purchaser price",
      ],
      isDisabled: false,
    },
    {
      value: "Waste",
      scope: 3,
      label:
        "4.3 Disposal Services (of solid or liquid waste) Used by an Organization",
      Units: [
        "kg",
        "lbs",
        "g",
        "short tons",
        "tonne",
        "2021 USD_ purchaser price",
        "2021 SGD_ purchaser price",
        "2021 THB_ purchaser price",
        "2021 TWD_ purchaser price",
        "2021 JPY_ purchaser price",
      ],
      isDisabled: false,
    },
    {
      value: "Use of Assets (through leased equipment) by an Organization",
      scope: 3,
      label: "4.4 Use of Assets (through leased equipment) by an Organization",
      Units: [
        "kg",
        "lbs",
        "g",
        "short tons",
        "tonne",
        "2021 USD_ purchaser price",
        "2021 SGD_ purchaser price",
        "2021 THB_ purchaser price",
        "2021 TWD_ purchaser price",
        "2021 JPY_ purchaser price",
      ],
      isDisabled: false,
    },
    {
      value:
        "Use of Services not Described in the above sub-categories by an Organization",
      scope: 3,
      label:
        "4.5 Use of Services not Described in the above sub-categories by an Organization",
      Units: [
        "kg",
        "lbs",
        "g",
        "short tons",
        "tonne",
        "2021 USD_ purchaser price",
        "2021 SGD_ purchaser price",
        "2021 THB_ purchaser price",
        "2021 TWD_ purchaser price",
        "2021 JPY_ purchaser price",
      ],
      isDisabled: false,
    },
    {
      value: "Use Stage of the Product",
      scope: 3,
      label: "5.1 Use Stage of the Product",
      Units: ["kg", "lbs", "g", "short tons", "tonne"],
      isDisabled: false,
    },
    {
      value: "Downstream Leased Assets",
      scope: 3,
      label: "5.2 Downstream Leased Assets",
      Units: ["kg", "lbs", "g", "short tons", "tonne"],
      isDisabled: false,
    },
    {
      value: "End of Life Stage of the Product",
      scope: 3,
      label: "5.3 End of Life Stage of the Product",
      Units: ["kg", "lbs", "g", "short tons", "tonne"],
      isDisabled: false,
    },
    {
      value: "Investments",
      scope: 3,
      label: "5.4 Investments",
      Units: ["kg", "lbs", "g", "short tons", "tonne"],
      isDisabled: false,
    },
    {
      value: "GHG Emissions or Removals from Other Sources",
      scope: 3,
      label: "6.1 Indirect GHG Emissions from other sources",
      Units: ["per FTE Working Hour"],
      isDisabled: false,
    },
    {
      value: "Emission Removal & Mitigation",
      label: "Emission Removal & Mitigation",
      Units: [
        "GJ",
        "Btu",
        "mmBtu",
        "therm",
        "kWh",
        "MWh",
        "MJ",
        "kg",
        "lbs",
        "g",
        "short tons",
        "tonne",
        "gal (US)",
        "Liter",
        "bbl",
        "scf",
        "ccf",
        "m3",
        "km",
        "nauticalmile",
        "mile",
        "Hphr",
        "MMcf gas to flare",
        "rig engine",
        "ha",
        "ha/yr",
        "head/yr",
      ],
      isDisabled: false,
    },
  ],
  TAB_HEADER_TOOLTIP: {
    Stationary_Combustion: "1.1_description",
    Mobile_Combustion: "1.2_description",
    Industrial_Processes: "1.3_description",
    Refrigerants_and_Fugitives: "1.4_description",
    Land_Use__Land_Use_Change_and_Forestry__LULUCF_: "1.5_description",

    Purchased_Electricity: "2.1_description",
    Imported_Energy: "2.2_description",

    Upstream_T_D: "3.1_description",
    Downstream_T_D: "3.2_description",
    Employee_Commuting: "3.3_description",
    Client_and_Visitor_Transport: "3.4_description",
    Business_Travel: "3.5_description",

    Purchased_Goods: "4.1_description",
    Capital_Goods_that_are_Purchased_and_Amortized_by_an_Organization:
      "4.2_description",
    Waste: "4.3_description",
    Use_of_Assets__through_leased_equipment__by_an_Organization:
      "4.4_description",
    Use_of_Services_not_Described_in_the_above_sub_categories_by_an_Organization:
      "4.5_description",

    Use_Stage_of_the_Product: "5.1_description",
    Downstream_Leased_Assets: "5.2_description",
    End_of_Life_Stage_of_the_Product: "5.3_description",
    Investments: "5.4_description",
    GHG_Emissions_or_Removals_from_Other_Sources: "6.1_description",
    Emission_Removal___Mitigation: "ERM_description",
  },
  WASTE_TREATMENT_METHOD: [
    {
      value: 1,
      label: "Landfill",
      methodOfCalculation: "Average-data method",
      isDisabled: true,
    },
    {
      value: 2,
      label: "Incinerated",
      methodOfCalculation: "Average-data method",
      isDisabled: false,
    },
    {
      value: 3,
      label: "Recycled Waste",
      methodOfCalculation: "Average-data method",
      isDisabled: true,
    },
  ],
  WATER_TREATMENT_METHOD: [
    { value: 1, label: "China" },
    { value: 2, label: "Japan" },
    { value: 3, label: "Indonesia" },
    { value: 4, label: "South Korea" },
    { value: 5, label: "Taiwan" },
  ],
  ENERGY_SOURCE: [
    {
      value: 1,
      label: "Solar Photovoltaic (PV)",
      category: "Emission Removal & Mitigation",
    },
    {
      value: 2,
      label: "Concentrated Solar Power",
      category: "Emission Removal & Mitigation",
    },
    {
      value: 3,
      label: "Wind-Turbines",
      category: "Emission Removal & Mitigation",
    },
    {
      value: 4,
      label: "Hydro Power Plant",
      category: "Emission Removal & Mitigation",
    },
    {
      value: 5,
      label: "Geothermal",
      category: "Emission Removal & Mitigation",
    },
  ],
  MONTHS: [
    "All",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  QUARTER: ["All", "Jan-Mar", "Apr-Jun", "Jul-Sep", "Oct-Dec"],
  DEVICE_CATEGORY_OPTIONS: [
    {
      value: 1,
      label: "Purchased Gas",
      category: "Refrigerants and Fugitives",
    },
    {
      value: 2,
      label: "Fire Supression Equipment",
      category: "Refrigerants and Fugitives",
    },
    {
      value: 3,
      label: "Refrigeration & Air Condition Equipment",
      category: "Refrigerants and Fugitives",
    },
    {
      value: 4,
      label: "Oil & Gas Industry",
      category: "Refrigerants and Fugitives",
    },
    {
      value: 5,
      label: "WD-40",
      category: "Refrigerants and Fugitives",
    },
    {
      value: 6,
      label: "Septic Tank",
      category: "Refrigerants and Fugitives",
    },
  ],
  TRANSPORT_TYPE_OPTIONS: [
    { value: 1, label: "Business Travel", category: "Upstream T&D" },
    { value: 2, label: "Employee Commute", category: "Upstream T&D" },
    { value: 3, label: "Upstream T&D", category: "Upstream T&D" },
  ],
  WASTE_TYPE_OPTIONS: [
    { value: 1, label: "Paper", category: "Waste" },
    { value: 2, label: "Wood", category: "Waste" },
    { value: 3, label: "Plastics", category: "Waste" },
    { value: 4, label: "Water Disposal", category: "Waste" },
    { value: 5, label: "General", category: "Waste" },
  ],
  WASTE_METHOD_OF_CALCULATION: [
    {
      value: 1,
      label: "Average-data method",
      category: "Waste",
      isDisabled: false,
    },
    {
      value: 2,
      label: "Supplier-specific method",
      category: "Waste",
      isDisabled: true,
    },
    {
      value: 3,
      label: "Waste-type specific method",
      category: "Waste",
      isDisabled: true,
    },
  ],
  CUSTOM_WASTE_METHOD_OF_CALCULATION: [
    {
      value: 1,
      label: "Average-data method",
      category: "Waste",
      isDisabled: false,
    },
    {
      value: 2,
      label: "Supplier-specific method",
      category: "Waste",
      isDisabled: false,
    },
    {
      value: 3,
      label: "Waste-type specific method",
      category: "Waste",
      isDisabled: false,
    },
  ],
  // Industries
  TRANSPORTATION: "Transportation",
  MANUFACTURING: "Manufacturing",
  COMERCIAL: "Commercial (Hotel,Mall,etc)",
  DATA_CENTER: "Data Center",
  CONSTRUCTION: "Construction",

  // Regions
  TAIWAN_REGION: "Taiwan",

  Refrigerant_Fugitives: "Refrigerants and Fugitives",
  Mobile_Combustion: "Mobile Combustion",
  Stationary_Combustion: "Stationary Combustion",
  Imported_Energy:
    "Imported energy (steam, heating, cooling and compressed air)",
  TRANSPORTATION: "Upstream T&D",
  EMISSION_MITIGATION_ACTIVITY_TYPE: [
    { value: 1, label: "Energy efficiency improvement", isDisabled: true },
    { value: 2, label: "Renewable energy", isDisabled: false },
    { value: 3, label: "Afforestation/Reforestation", isDisabled: true },
  ],
  NEW_EMISSIONS: [
    {
      label: "Scope 1 | Category 1",
      value: "Scope 1 | Category 1",
      scope: 1,
      category: [
        {
          key: "Stationary Combustion",
          label: "1.1 Stationary Combustion",
          isDisabled: false,
          value: 1,
        },
        {
          key: "Mobile Combustion",
          label: "1.2 Mobile Combustion",
          isDisabled: false,
          value: 2,
        },
        {
          key: "Industrial Processes",
          label: "1.3 Industrial Processes",
          isDisabled: false,
          value: 3,
        },
        {
          key: "Refrigerants and Fugitives",
          label: "1.4 Fugitive Emissions",
          isDisabled: false,
          value: 4,
        },
        {
          key: "Land Use, Land Use Change and Forestry (LULUCF)",
          label: "1.5 Land Use, Land Use Change and Forestry (LULUCF)",
          isDisabled: false,
          value: 5,
        },
      ],
      isDisabled: false,
    },
    {
      label: "Scope 2 | Category 2",
      value: "Scope 2 | Category 2",
      scope: 2,
      category: [
        {
          value: "Purchased Electricity",
          key: "Purchased Electricity",
          label: "2.1 Imported Electricity",
          isDisabled: false,
          value: 1,
        },
        {
          value: "Imported Energy",
          key: "Imported Energy",
          label: "2.2 Imported Energy",
          isDisabled: true,
          value: 2,
        },
      ],
      isDisabled: false,
    },
    {
      label: "Scope 3 | Category 3",
      value: "Scope 3 | Category 3",
      scope: 3,
      category: [
        {
          key: "Upstream T&D",
          label: "3.1 Upstream Transport and Distribution for Goods",
          isDisabled: false,
          value: 1,
        },
        {
          key: "Downstream T&D",
          label: "3.2 Downstream Transport and Distribution for Goods",
          isDisabled: false,
          value: 2,
        },
        {
          key: "Employee Commuting",
          label: "3.3 Employee Commuting",
          isDisabled: false,
          value: 3,
        },
        {
          key: "Client and Visitor Transport",
          label: "3.4 Client and Visitor Transport",
          isDisabled: false,
          value: 4,
        },
        {
          key: "Business Travel",
          label: "3.5 Business Travel",
          isDisabled: false,
          value: 5,
        },
      ],
      isDisabled: false,
    },
    {
      label: "Scope 3 | Category 4",
      value: "Scope 3 | Category 4",
      scope: 3,
      category: [
        {
          key: "Purchased Goods",
          label: "4.1 Goods Purchased by an Organization",
          isDisabled: false,
          value: 1,
        },
        {
          key: "Capital Goods that are Purchased and Amortized by an Organization",
          label:
            "4.2 Capital Goods that are Purchased and Amortized by an Organization",
          isDisabled: false,
          value: 2,
        },
        {
          key: "Waste",
          label:
            "4.3 Disposal Services (of solid or liquid waste) Used by an Organization",
          isDisabled: false,
          value: 3,
        },
        {
          key: "Use of Assets (through leased equipment) by an Organization",
          label:
            "4.4 Use of Assets (through leased equipment) by an Organization",
          isDisabled: false,
          value: 4,
        },
        {
          key: "Use of Services not Described in the above sub-categories by an Organization",
          label:
            "4.5 Use of Services not Described in the above sub-categories by an Organization",
          isDisabled: false,
          value: 5,
        },
      ],
      isDisabled: false,
    },
    {
      label: "Scope 3 | Category 5",
      value: "Scope 3 | Category 5",
      scope: 3,
      category: [
        {
          key: "Use Stage of the Product",
          label: "5.1 Use Stage of the Product",
          isDisabled: false,
          value: 1,
        },
        {
          key: "Downstream Leased Assets",
          label: "5.2 Downstream Leased Assets",
          isDisabled: false,
          value: 2,
        },
        {
          key: "End of Life Stage of the Product",
          label: "5.3 End of Life Stage of the Product",
          isDisabled: false,
          value: 3,
        },
        {
          key: "Investments",
          label: "5.4 Investments",
          isDisabled: false,
          value: 4,
        },
      ],
      isDisabled: false,
    },
    {
      label: "Scope 3 | Category 6",
      value: "Scope 3 | Category 6",
      scope: 3,
      category: [
        {
          key: "GHG Emissions or Removals from Other Sources",
          label: "6.1 Indirect GHG Emissions from other sources",
          isDisabled: false,
        },
      ],
      isDisabled: false,
    },
    {
      label: "Emission Removal & Mitigation",
      value: "Emission Removal & Mitigation",
      scope: "EmissionRemovalAndMitigation",
      category: [
        {
          key: "Emission Removal & Mitigation",
          label: "Emission Removal & Mitigation",
          isDisabled: false,
        },
      ],
      isDisabled: true,
    },
  ],
  EMISSION_TYPE_OPTIONS: [{ key: 1, label: "Fossil" }],
  EMISSION_UNIT_OPTIONS: [
    { value: 1, label: "gal (US)" },
    { value: 2, label: "Liter" },
    { value: 3, label: "bbl" },
    { value: 4, label: "scf" },
    { value: 5, label: "ccf" },
    { value: 6, label: "m3" },
    { value: 7, label: "Btu" },
    { value: 8, label: "mmBtu" },
    { value: 9, label: "therm" },
    { value: 10, label: "kWh" },
    { value: 11, label: "MWh" },
    { value: 12, label: "MJ" },
    { value: 13, label: "GJ" },
    { value: 14, label: "mile" },
    { value: 15, label: "nautical mile" },
    { value: 16, label: "km" },
    { value: 17, label: "passenger-mile" },
    { value: 18, label: "passenger-km" },
    { value: 19, label: "tonne-km" },
    { value: 20, label: "ton-mile" },
    { value: 21, label: "tonne" },
    { value: 22, label: "kg" },
    { value: 23, label: "per unit" },
    { value: 24, label: "kl" },
  ],
  TABLE_COLUMNS: [
    {
      cat: "Stationary Combustion",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Activity Name",
          key: "equipmentType",
          dataType: "selectInput",
          newKey: "activityName",
        },
        {
          label: "Name/Number",
          key: "assetName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Emission Factor Source",
          key: "source",
          dataType: "selectInput",
        },
        {
          label: "Emission Factor Name",
          key: "fuelType",
          dataType: "selectInput",
          customKey: "calculateMethod",
          newKey: "emissionFactorName",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
        // {
        //   label: "GWP",
        //   key: "gwpValue",
        //   dataType: "textInput",
        //   fieldType: "text",
        // },
        {
          label: "Biomass",
          key: "isBiomass",
          dataType: "radioInput",
          fieldType: "Boolean",
        },
      ],
    },
    {
      cat: "Refrigerants and Fugitives",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Equipment Category",
          key: "equipmentCategory",
          dataType: "selectInput",
        },
        {
          label: "Activity Name",
          key: "equipmentType",
          dataType: "selectInput",
          newKey: "activityName",
        },
        {
          label: "Name/Number",
          key: "assetName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Emission Factor Source",
          key: "source",
          dataType: "selectInput",
        },

        // { label: "Emission Type", key: "fuelType", dataType: "selectInput", customKey: "calculateMethod" },

        {
          label: "Method of Calculation",
          key: "activityType",
          customKey: "calculateType",
          dataType: "selectInput",
          newKey: "methodOfCalculation",
        },
        // {
        //   label: "Facility Name",
        //   key: "calculateMethod",
        //   dataType: "selectInput",
        // },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
        {
          label: "GWP",
          key: "gwpValue",
          dataType: "textInput",
          fieldType: "text",
        },
        // {
        //   label: "Biomass",
        //   key: "isBiomass",
        //   dataType: "radioInput",
        //   fieldType: "Boolean",
        // },
      ],
    },
    {
      cat: "Mobile Combustion",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Activity Name",
          key: "vehicleType",
          dataType: "selectInput",
          newKey: "activityName",
        },
        {
          label: "Name/Number",
          key: "assetName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Emission Factor Source",
          key: "source",
          dataType: "selectInput",
        },
        {
          label: "Emission Factor Name",
          key: "fuelType",
          dataType: "selectInput",
          customKey: "calculateMethod",
          newKey: "emissionFactorName",
        },
        // {
        //   label: "Activity Type",
        //   key: "activityType",
        //   dataType: "selectInput",
        // },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
        {
          label: "Biomass",
          key: "isBiomass",
          dataType: "radioInput",
          fieldType: "Boolean",
        },
      ],
    },
    {
      cat: "Industrial Processes",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Activity Name",
          key: "activityType",
          dataType: "selectInput",
          newKey: "activityName",
        },
        {
          label: "Name/Number",
          key: "assetName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Emission Factor Source",
          key: "source",
          dataType: "selectInput",
        },
        {
          label: "Emission Factor Name",
          key: "fuelType",
          dataType: "selectInput",
          customKey: "calculateMethod",
          newKey: "emissionFactorName",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
        // {
        //   label: "GWP",
        //   key: "gwpValue",
        //   dataType: "textInput",
        //   fieldType: "text",
        // },
        {
          label: "Biomass",
          key: "isBiomass",
          dataType: "radioInput",
          fieldType: "Boolean",
        },
      ],
    },
    {
      cat: "Purchased Electricity",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Energy Type",
          key: "energyType",
          customKey: "calculateMethod",
          dataType: "selectInput",
        },
        {
          label: "Energy Supplier",
          key: "supplierName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
          newKey: "assetName",
        },
        {
          label: "Emission Factor Source",
          key: "source",
          dataType: "selectInput",
          fieldType: "text",
        },
        {
          label: "Method of Calculation",
          key: "emissionFactor",
          customKey: "calculateType",
          dataType: "selectInput",
          newKey: "methodOfCalculation",
        },
        // { label: "Location", key: "calculateMethod", dataType: "selectInput" },
        {
          label: "Type",
          key: "type",
          dataType: "selectInput",
          fieldType: "text",
        },
        {
          label: "Emission Factor Name",
          key: "calculateMethod",
          dataType: "selectInput",
          newKey: "emissionFactorName",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Imported Energy",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Energy Supplier / Name",
          key: "supplierName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Energy Type",
          key: "energyType",
          dataType: "selectInput",
        },
        {
          label: "Method of Calculation",
          key: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "Emission Type",
          key: "calculateMethod",
          customKey: "fuelType",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Upstream T&D",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Transportation Name",
          key: "transportationName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Mode of Transport",
          key: "transportMode",
          dataType: "selectInput",
        },
        {
          label: "Vehicle Type",
          key: "vehicleType",
          dataType: "selectInput",
          customKey: "calculateMethod",
        },
        {
          label: "Method of Calculation",
          key: "activityType",
          customKey: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Downstream T&D",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Transportation Name",
          key: "transportationName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Mode of Transport",
          key: "transportMode",
          dataType: "selectInput",
        },
        {
          label: "Vehicle Type",
          key: "vehicleType",
          dataType: "selectInput",
          customKey: "calculateMethod",
        },
        {
          label: "Method of Calculation",
          key: "activityType",
          customKey: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Employee Commuting",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Transportation Name",
          key: "transportationName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Mode of Transport",
          key: "transportMode",
          dataType: "selectInput",
        },
        {
          label: "Vehicle Type",
          key: "vehicleType",
          dataType: "selectInput",
          customKey: "calculateMethod",
        },
        {
          label: "Method of Calculation",
          key: "activityType",
          customKey: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Client and Visitor Transport",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Transportation Name",
          key: "transportationName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Mode of Transport",
          key: "transportMode",
          dataType: "selectInput",
        },
        {
          label: "Vehicle Type",
          key: "vehicleType",
          dataType: "selectInput",
          customKey: "calculateMethod",
        },
        {
          label: "Method of Calculation",
          key: "activityType",
          customKey: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Business Travel",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Transportation Name",
          key: "transportationName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        // {
        //   label: "Mode of Transport / Accommodation",
        //   key: "transportMode",
        //   dataType: "selectInput",
        // },
        {
          label: "Vehicle Type / Country",
          key: "vehicleType",
          dataType: "selectInput",
          customKey: "calculateMethod",
        },
        {
          label: "Method of Calculation",
          key: "activityType",
          customKey: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Waste",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Waste Management Vendor Name",
          key: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Method of Calculation",
          key: "methodOfCalculation",
          customKey: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "Waste Treatment Method",
          key: "wasteTreatmentMethod",
          dataType: "selectInput",
        },
        {
          label: "Material",
          key: "material",
          customKey: "calculateMethod",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Emission Removal & Mitigation",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Name",
          key: "assetName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Scope/Category Type",
          key: "scopeCategoryType",
          dataType: "selectInput",
        },
        {
          label: "Sub-Category",
          key: "subCategory",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Emission Mitigation Activity type",
          key: "mitigationActivityType",
          dataType: "selectInput",
        },
        { label: "Location", key: "calculateMethod", dataType: "selectInput" },
        {
          label: "Method Of Calculation",
          key: "methodOfCalculation",
          dataType: "selectInput",
        },
        {
          label: "Emission Factor",
          key: "emissionFactorValue",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Purchased Goods",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Supplier Name",
          key: "supplierName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Activity Name",
          key: "equipmentType",
          dataType: "selectInput",
        },
        {
          label: "Emission Source",
          key: "emissionSource",
          dataType: "selectInput",
          fieldType: "text",
        },
        {
          label: "Purchased Good",
          key: "purchasedGood",
          customKey: "calculateMethod",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Capital Goods that are Purchased and Amortized by an Organization",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Supplier Name",
          key: "supplierName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Emission Source",
          key: "emissionSource",
          dataType: "selectInput",
          fieldType: "text",
        },
        {
          label: "Emission Type",
          key: "capitalGood",
          customKey: "calculateMethod",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Use Stage of the Product",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        { label: "Name", key: "name", dataType: "selectInput" },
        {
          label: "Emission Type",
          key: "calculateMethod",
          dataType: "selectInput",
        },
        {
          label: "Method of Calculation",
          key: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Downstream Leased Assets",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        { label: "Name", key: "name", dataType: "selectInput" },
        {
          label: "Emission Type",
          key: "calculateMethod",
          dataType: "selectInput",
        },
        {
          label: "Method of Calculation",
          key: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "End of Life Stage of the Product",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        { label: "Name", key: "name", dataType: "selectInput" },
        {
          label: "Emission Type",
          key: "calculateMethod",
          dataType: "selectInput",
        },
        {
          label: "Material",
          key: "material",
          dataType: "selectInput",
        },
        {
          label: "Method of Calculation",
          key: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Investments",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        { label: "Name", key: "name", dataType: "selectInput" },
        {
          label: "Emission Type",
          key: "calculateMethod",
          dataType: "selectInput",
        },
        {
          label: "Method of Calculation",
          key: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Use of Assets (through leased equipment) by an Organization",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Transportation Name",
          key: "transportationName",
          customKey: "name",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Mode of Transport",
          key: "transportMode",
          dataType: "selectInput",
        },
        {
          label: "Vehicle Type",
          key: "vehicleType",
          dataType: "selectInput",
          customKey: "calculateMethod",
        },
        {
          label: "Method of Calculation",
          key: "activityType",
          customKey: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Use of Services not Described in the above sub-categories by an Organization",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        { label: "Name", key: "name", dataType: "selectInput" },
        {
          label: "Emission Type",
          key: "calculateMethod",
          dataType: "selectInput",
        },
        {
          label: "Method of Calculation",
          key: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "GHG Emissions or Removals from Other Sources",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        { label: "Name", key: "name", dataType: "selectInput" },
        {
          label: "Emission Type",
          key: "calculateMethod",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
      ],
    },
    {
      cat: "Land Use, Land Use Change and Forestry (LULUCF)",
      dataFields: [
        {
          label: "Entity Name",
          key: "companyName",
          customKey: "companyName",
          dataType: "textInput",
          fieldType: "text",
        },
        {
          label: "Name",
          key: "assetName",
          dataType: "textInput",
          customKey: "name",
        },
        {
          label: "Activity Name",
          key: "activityType",
          dataType: "selectInput",
        },
        {
          label: "Emission Source",
          key: "emissionSource",
          dataType: "selectInput",
        },
        {
          label: "Emission Type",
          key: "calculateMethod",
          dataType: "selectInput",
        },
        {
          label: "Method of Calculation",
          key: "calculateType",
          dataType: "selectInput",
        },
        {
          label: "GHG Emission Factor",
          key: "baseEmissionFactor",
          dataType: "textInput",
          fieldType: "number",
        },
        {
          label: "Biomass",
          key: "isBiomass",
          dataType: "radioInput",
          fieldType: "Boolean",
        },
      ],
    },
  ],

  TARGET_SIDEBAR_ITEMS: [
    { title: "Home", icon: <i className="bi bi-house-fill"></i> },
    { title: "List", icon: <i className="bi bi-list-task"></i> },
    { title: "Chiller", icon: <AddBoxIcon style={{ fontSize: "32px" }} /> },
  ],
  TRANSCATION_COUNT: 4,
  UNIVERSITY: "University",
  BUSINESS: "Business",
  KCDat_ID: "63f2e77a820fc55ba97aa0e3",
  KUMO_SYSTEM_ADMIN_EMAIL: "superadmin@gmail.com",
  KUMO_SYSTEM_ADMIN_Id: "63d20acefeec8524142bdbb8",
  SOLAR_REPORT_CHART: "Solar Report Chart",

  PURPOSE_OF_GHG_EMISSIONS_REPORTING: [
    { value: 1, label: "Compliance" },
    { value: 2, label: "Internal Reporting" },
    { value: 3, label: "Stakeholders' Requirement" },
  ],

  INDUSTRY_CLASSIFICATION: [
    { value: 1, label: "Agriculture and Fishing" },
    { value: 2, label: "Mining and Quarrying" },
    { value: 3, label: "Manufacturing" },
    { value: 4, label: "Electricity, Gas, Stream and Air-Conditioning Supply" },
    {
      value: 5,
      label:
        "Water Supply; Sewerage, Waste Management and Remediation Activities",
    },
    { value: 6, label: "Construction" },
    { value: 7, label: "Wholesale And Retail Trade" },
    { value: 8, label: "Transportation And Storage" },
    { value: 9, label: "Accommodation And Food Service Activities" },
    { value: 10, label: "Information And Communications" },
    { value: 11, label: "Financial And Insurance Activities" },
    { value: 12, label: "Real Estate Activities" },
    { value: 13, label: "Professional, Scientific And Technical Activities" },
    { value: 14, label: "Administrative And Support Service Activities" },
    { value: 15, label: "Public Administration And Defence" },
    { value: 16, label: "Education" },
    { value: 17, label: "Health And Social Services" },
    { value: 18, label: "Arts, Entertainment And Recreation" },
    { value: 19, label: "Other Service Activities" },
    {
      value: 20,
      label: "Activities Of Extra-Territorial Organisations And Bodies",
    },
  ],

  COMPANY_TYPE: [
    { value: 1, label: "Multi-national Corporation (MNC)" },
    { value: 2, label: "Small-Medium Enterprise (SME)" },
    { value: 3, label: "Government Organization" },
    { value: 4, label: "Non-Profit Organization" },
  ],

  LANGUAGE_TYPE: [
    { value: "Taiwan", label: "Taiwan" },
    { value: "Chinese", label: "Chinese" },
    { value: "Japan", label: "Japan" },
    { value: "Thailand", label: "Thailand" },
    { value: "Italy", label: "Italy" },
    { value: "German", label: "German" },
  ],

  SUPER_LEVEL: "super_level",
  SUPER_OPERATOR_LEVEL: "super_operator_level",
  ADMIN_LEVEL: "admin_level",
  ADMIN_OPERATOR_LEVEL: "admin_operator_level",

  // Audition status
  VERIFIED: "Verified",
  REJECTED: "Rejected",
  PENDING: "Pending",

  // SYSTEM_SUB_CATEGORIES
  CAT_1_1: "Stationary Combustion",
  CAT_1_2: "Mobile Combustion",
  CAT_1_3: "Industrial Processes",
  CAT_1_4: "Refrigerants and Fugitives",
  CAT_1_5: "Land Use, Land Use Change and Forestry (LULUCF)",
  CAT_2_1: "Purchased Electricity",
  CAT_2_2: "Imported Energy",
  CAT_3_1: "Upstream T&D",
  CAT_3_2: "Downstream T&D",
  CAT_3_3: "Employee Commuting",
  CAT_3_4: "Client and Visitor Transport",
  CAT_3_5: "Business Travel",
  CAT_4_1: "Purchased Goods",
  CAT_4_2: "Capital Goods that are Purchased and Amortized by an Organization",
  CAT_4_3: "Waste",
  CAT_4_4: "Use of Assets (through leased equipment) by an Organization",
  CAT_4_5:
    "Use of Services not Described in the above sub-categories by an Organization",
  CAT_5_1: "Use Stage of the Product",
  CAT_5_2: "Downstream Leased Assets",
  CAT_5_3: "End of Life Stage of the Product",
  CAT_5_4: "Investments",
  CAT_6_1: "GHG Emissions or Removals from Other Sources",

  PCFData: {
    ProductCategory: [
      {
        label: "Apparel",
        value: "Apparel",
      },
      {
        label: "Bags & Accessories",
        value: "Bags & Accessories",
      },
      {
        label: "Books, Movie, Music, Game",
        value: "Books, Movie, Music, Game",
      },
      {
        label: "Consumer Electronic",
        value: "Consumer Electronic",
      },
      {
        label: "Electrical Distribution",
        value: "Electrical Distribution",
      },
      {
        label: "Shoe",
        value: "Shoe",
      },
    ],
    ProductType: [
      {
        label: "T-shirt",
        value: "T-shirt",
        productCategory: "Apparel",
      },
      {
        label: "Jean",
        value: "Jean",
        productCategory: "Apparel",
      },
      {
        label: "Dress",
        value: "Dress",
        productCategory: "Apparel",
      },
      {
        label: "Tote bag",
        value: "Tote bag",
        productCategory: "Bags & Accessories",
      },
      {
        label: "Suitcase",
        value: "Suitcase",
        productCategory: "Bags & Accessories",
      },
      {
        label: "Backpack",
        value: "Backpack",
        productCategory: "Bags & Accessories",
      },
      {
        label: "Other bags & accessories",
        value: "Other bags & accessories",
        productCategory: "Bags & Accessories",
      },
      {
        label: "Board game",
        value: "Board game",
        productCategory: "Books, Movie, Music, Game",
      },
      {
        label: "CD for music or video",
        value: "CD for music or video",
        productCategory: "Books, Movie, Music, Game",
      },
      {
        label: "Book",
        value: "Book",
        productCategory: "Books, Movie, Music, Game",
      },
      {
        label: "Keyboard",
        value: "Keyboard",
        productCategory: "Consumer Electronic",
      },
      {
        label: "Computer mouse",
        value: "Computer mouse",
        productCategory: "Consumer Electronic",
      },
      {
        label: "Shoes average",
        value: "Shoes average",
        productCategory: "Shoe",
      },
      {
        label: "Protective Devices",
        value: "Protective Devices",
        productCategory: "Electrical Distribution",
      },
    ],
    AdditionalGHGInventory: [
      {
        label: "Carbon dioxide (CO2)",
        value: "Carbon dioxide (CO2)",
      },
      {
        label: "Methane (CH4)",
        value: "Methane (CH4)",
      },
      {
        label: "Nitrous oxide (N2O)",
        value: "Nitrous oxide (N2O)",
      },
      {
        label: "Hydrofluorocarbons (HFCs)",
        value: "Hydrofluorocarbons (HFCs)",
      },
      {
        label: "Perfluorocarbons (PFCs)",
        value: "Perfluorocarbons (PFCs)",
      },
      {
        label: "Sulphur hexafluoride (SF6)",
        value: "Sulphur hexafluoride (SF6)",
      },
      {
        label: "Nitrogen trifluoride (NF3)",
        value: "Nitrogen trifluoride (NF3)",
      },
    ],
    TypeOfInvertory: [
      {
        label: "Cradle to grave",
        value: "Cradle to grave",
      },
      {
        label: "Cradle to gate",
        value: "Cradle to gate",
      },
      {
        label: "Gate to gate",
        value: "Gate to gate",
      },
      {
        label: "Gate to grave",
        value: "Gate to grave",
      },
      {
        label: "Unit operation",
        value: "Unit operation",
      },
    ],
    lifeCycleStages: [
      {
        label: "(4)Use-stage of Product",
        value: "(4)Use-stage of Product",
        id: 4,
        order: 4,
      },
      {
        label: "(1)Material acquisition & pre-processing",
        value: "(1)Material acquisition & pre-processing",
        id: 1,
        order: 1,
      },
      {
        label: "(2)Production",
        value: "(2)Production",
        id: 2,
        order: 2,
      },
      {
        label: "(3)Distribution & Storage",
        value: "(3)Distribution & Storage",
        id: 3,
        order: 3,
      },
      {
        label: "(5)End-of-life stage of Product",
        value: "(5)End-of-life stage of Product",
        id: 5,
        order: 5,
      },
    ].sort((a, b) => a.order - b.order),
    periodOfInventory: [
      {
        label: "2024",
        value: "2024",
      },
      {
        label: "2023",
        value: "2023",
      },
      {
        label: "2022",
        value: "2022",
      },
      {
        label: "2021",
        value: "2021",
      },
      {
        label: "2020",
        value: "2020",
      },
      {
        label: "2019",
        value: "2019",
      },
      {
        label: "2018",
        value: "2018",
      },
    ],
    allocationMethod: [
      {
        label: "Economic",
        value: "Economic",
      },
      {
        label: "Physical",
        value: "Physical",
      },
      {
        label: "System Expansion",
        value: "System Expansion",
      },
      // {
      //   label:"Criticality Allocation",value:"Criticality Allocation"
      // },
      // {
      //   label:"Redundancy Allocation",value:"Redundancy Allocation"
      // },
      // {
      //   label:"Selective Coordination Allocation",value:"Selective Coordination Allocation"
      // }
    ],
    materialType: [
      {
        label: "Copper",
        value: "Copper",
      },
      {
        label: "Steel",
        value: "Steel",
      },
    ],
    materialName: [
      {
        label: "Copper - electrical copper",
        value: "Copper - electrical copper",
        materialType: "Copper",
      },
      {
        label: "Copper - copper wire",
        value: "Copper - copper wire",
        materialType: "Copper",
      },
      {
        label: "Copper - other copper products",
        value: "Copper - other copper products",
        materialType: "Copper",
      },
      {
        label: "Steel - cold-rolled structural",
        value: "Steel - cold-rolled structural",
        materialType: "Steel",
      },
      {
        label: "Steel - structural alloy steel",
        value: "Steel - structural alloy steel",
        materialType: "Steel",
      },
      {
        label: "Steel - electrogalvanized steel sheet",
        value: "Steel - electrogalvanized steel sheet",
        materialType: "Steel",
      },
    ],
    activityType: [
      {
        label: "Water",
        value: "Water",
      },
      {
        label: "Electricity",
        value: "Electricity",
      },
    ],
    activityName: [
      {
        label: "Water - Industrial A1",
        value: "Water - Industrial A1",
        activityType: "Water",
      },
      {
        label: "Water - Industrial A2",
        value: "Water - Industrial A2",
        activityType: "Water",
      },
      {
        label: "Water - Industrial B1",
        value: "Water - Industrial B1",
        activityType: "Water",
      },
      {
        label: "Water - Tap A1",
        value: "Water - Tap A1",
        activityType: "Water",
      },
      {
        label: "Water - Tap A2",
        value: "Water - Tap A2",
        activityType: "Water",
      },
      {
        label: "Water - Tap B1",
        value: "Water - Tap B1",
        activityType: "Water",
      },
      {
        label: "Water - Tap Boiler",
        value: "Water - Tap Boiler",
        activityType: "Water",
      },
      {
        label: "Electricity - A1",
        value: "Electricity - A1",
        activityType: "Electricity",
      },
    ],
    Stage: [
      {
        label: "Domestic",
        value: "Domestic",
      },
      {
        label: "Overseas",
        value: "Overseas",
      },
    ].sort((a, b) => a.value - b.value),
    modeOfTransport: [
      {
        label: "Land",
        value: "Land",
      },
      {
        label: "Maritime",
        value: "Maritime",
      },
    ],
    unitOfMeasure: [
      {
        label: "g",
        value: "g",
      },
      {
        label: "Wh",
        value: "Wh",
      },
      {
        label: "km",
        value: "km",
      },
    ],
    destination: [
      {
        label: "Sakai,Japan",
        value: "Sakai,Japan",
      },
      {
        label: "MEFW,Japan",
        value: "MEFW,Japan",
      },
      {
        label: "Fukuyama,Japan",
        value: "Fukuyama,Japan",
      },
    ],
    disposalType: [
      {
        label: "Recycling",
        value: "Recycling",
      },
      {
        label: "Landfill",
        value: "Landfill",
      },
    ],
    energySource: [
      {
        label: "Nuclear Power",
        value: "Nuclear Power",
      },
      {
        label: "Hydrogen",
        value: "Hydrogen",
      },
    ].sort((a, b) => a.value - b.value),
    proportion: [
      {
        label: "Energy Recovery",
        value: "Energy Recovery",
      },
      {
        label: "Recycling",
        value: "Recycling",
      },
    ],
    treatmentMethod: [
      {
        label: "Reuse",
        value: "Reuse",
      },
      {
        label: "Landfill",
        value: "Landfill",
      },
    ],
  },
  AR5_CO2: 1,
  AR5_CH4: 28,
  AR5_N2O: 265,
  AR6_CO2: 1,
  AR6_CH4: 27.9,
  AR6_N2O: 273,
  GROUP_REPORT: "group_report",
  INDIVIDUAL: "individual",
  YEARLY: "yearly",
  MONTHLY: "monthly",
};

export const CompanyStatus = {
  RECOVERY: 0,
  REQUEST_DELETE: 1,
  ACCEPT_DELETE: 2,
};

export const DataConsumptionDate = {
  format: {
    day: "YYYY-MM-DD",
    month: "YYYY-MM",
    year: "YYYY",
  },
  displayFormat: {
    day: "DD/MM/YYYY",
    month: "MM/YYYY",
    year: "YYYY",
  },
  inputFormat: {
    day: "dd/MM/yyyy",
    month: "MM/yyyy",
    year: "yyyy",
  },
};

export const BLUE_ONION_DUMMY_DATA = [
  {
    suggestionCompany: "ISIN, Ticker",
    data: {
      companyProfile: {
        // "suggestCompanyType": "Suggestions",
        suggestCompanyType: "ISIN, Ticker",
        // "industry" : "Air Transportation",
        // "companyType": "HQ",
        // "HQCountry": "Taiwan",
        // "SICCode": "7890",
        SBTiTargetFiles: [],
        isGHGInventory: true,
        isSBTiTarget: true,
        isIsoOrg: false,
        isIsoPCF: false,
        isEPD: false,
        isCBAM: false,
        isSustainabilityReport: false,
        isOthers: false,
        GHGInventoryFiles: [],
        ISOOrgFiles: [],
        ISOPCFFiles: [],
        EPDFiles: [],
        CBAMFiles: [],
        SustainabilityReportFiles: [],
        OthersFiles: [],
        SrReportFiles: [],
        IsoReportFiles: [],
        type: "company",
        isParisAggrement: true,
        SBTiTemperature: "34",
        emiReductionYear: 2024,
        emiReductionRatio: "34",
        regressionModel: "34",
        baselineYear: 2024,
        targetYear: 2024,
      },
    },
  },
  {
    suggestionCompany: "Sustainability Rating",
    data: {
      companyProfile: {
        // "suggestCompanyType": "Suggestions",
        suggestCompanyType: "Sustainability Rating",
        // "industry" : "Alternative Energy",
        // "companyType": "HQ",
        // "HQCountry": "Taiwan",
        // "SICCode": "4321",
        SBTiTargetFiles: [],
        isGHGInventory: true,
        isSBTiTarget: true,
        isIsoOrg: true,
        isIsoPCF: false,
        isEPD: false,
        isCBAM: false,
        isSustainabilityReport: false,
        isOthers: false,
        GHGInventoryFiles: [],
        ISOOrgFiles: [],
        ISOPCFFiles: [],
        EPDFiles: [],
        CBAMFiles: [],
        SustainabilityReportFiles: [],
        OthersFiles: [],
        SrReportFiles: [],
        IsoReportFiles: [],
        type: "company",
        isParisAggrement: true,
        SBTiTemperature: "56",
        emiReductionYear: 2024,
        emiReductionRatio: "56",
        regressionModel: "56",
        baselineYear: 2024,
        targetYear: 2024,
      },
    },
  },
  {
    suggestionCompany: "UNGC Rating",
    data: {
      companyProfile: {
        // "suggestCompanyType": "Suggestions",
        suggestCompanyType: "UNGC Rating",
        isSBTiTarget: true,
        // "industry" : "Automobiles",
        // "companyType": "HQ",
        // "HQCountry": "Taiwan",
        // "SICCode": "8765",
        SBTiTargetFiles: [],
        isGHGInventory: true,
        isIsoOrg: true,
        isIsoPCF: true,
        isEPD: false,
        isCBAM: false,
        isSustainabilityReport: false,
        isOthers: false,
        GHGInventoryFiles: [],
        ISOOrgFiles: [],
        ISOPCFFiles: [],
        EPDFiles: [],
        CBAMFiles: [],
        SustainabilityReportFiles: [],
        OthersFiles: [],
        SrReportFiles: [],
        IsoReportFiles: [],
        type: "company",
        isParisAggrement: true,
        SBTiTemperature: "90",
        emiReductionYear: 2024,
        emiReductionRatio: "90",
        regressionModel: "90",
        baselineYear: 2024,
        targetYear: 2024,
      },
    },
  },
  {
    suggestionCompany: "Country",
    data: {
      companyProfile: {
        // "suggestCompanyType": "Suggestions",
        suggestCompanyType: "Country",
        // "industry" : "Beverages",
        // "companyType": "HQ",
        // "HQCountry": "Taiwan",
        // "SICCode": "9876",
        SBTiTargetFiles: [],
        isGHGInventory: false,
        isSBTiTarget: true,
        isIsoOrg: false,
        isIsoPCF: false,
        isEPD: false,
        isCBAM: false,
        isSustainabilityReport: false,
        isOthers: false,
        GHGInventoryFiles: [],
        ISOOrgFiles: [],
        ISOPCFFiles: [],
        EPDFiles: [],
        CBAMFiles: [],
        SustainabilityReportFiles: [],
        OthersFiles: [],
        SrReportFiles: [],
        IsoReportFiles: [],
        type: "company",
        isParisAggrement: true,
        SBTiTemperature: "12",
        emiReductionYear: 2024,
        emiReductionRatio: "12",
        regressionModel: "12",
        baselineYear: 2024,
        targetYear: 2024,
      },
    },
  },
  {
    suggestionCompany: "Exchange",
    data: {
      companyProfile: {
        // "suggestCompanyType": "Suggestions",
        suggestCompanyType: "Exchange",
        // "industry" : "Chemicals",
        // "companyType": "HQ",
        // "HQCountry": "Taiwan",
        // "SICCode": "4567",
        SBTiTargetFiles: [],
        isGHGInventory: false,
        isSBTiTarget: true,
        isIsoOrg: false,
        isIsoPCF: false,
        isEPD: false,
        isCBAM: false,
        isSustainabilityReport: false,
        isOthers: false,
        GHGInventoryFiles: [],
        ISOOrgFiles: [],
        ISOPCFFiles: [],
        EPDFiles: [],
        CBAMFiles: [],
        SustainabilityReportFiles: [],
        OthersFiles: [],
        SrReportFiles: [],
        IsoReportFiles: [],
        type: "company",
        isParisAggrement: true,
        SBTiTemperature: "89",
        emiReductionYear: 2024,
        emiReductionRatio: "89",
        regressionModel: "89",
        baselineYear: 2024,
        targetYear: 2024,
      },
    },
  },
  {
    suggestionCompany: "Industry, Position & Percentile",
    data: {
      companyProfile: {
        // "suggestCompanyType": "Suggestions",
        suggestCompanyType: "Industry, Position & Percentile",
        // "industry" : "Chemicals",
        // "companyType": "HQ",
        // "HQCountry": "Taiwan",
        // "SICCode": "3456",
        SBTiTargetFiles: [],
        isGHGInventory: false,
        isSBTiTarget: true,
        isIsoOrg: false,
        isIsoPCF: false,
        isEPD: false,
        isCBAM: false,
        isSustainabilityReport: true,
        isOthers: false,
        GHGInventoryFiles: [],
        ISOOrgFiles: [],
        ISOPCFFiles: [],
        EPDFiles: [],
        CBAMFiles: [],
        SustainabilityReportFiles: [],
        OthersFiles: [],
        SrReportFiles: [],
        IsoReportFiles: [],
        type: "company",
        isParisAggrement: true,
        SBTiTemperature: "67",
        emiReductionYear: 2024,
        emiReductionRatio: "67",
        regressionModel: "67",
        baselineYear: 2024,
        targetYear: 2024,
      },
    },
  },
  {
    suggestionCompany: "Total Scope 1 and 2 (both company and ind. Average)",
    data: {
      companyProfile: {
        // "suggestCompanyType": "Suggestions",
        suggestCompanyType:
          "Total Scope 1 and 2 (both company and ind. Average)",
        // "industry" : "Chemicals",
        // "companyType": "HQ",
        // "HQCountry": "Taiwan",
        // "SICCode": "7654",
        SBTiTargetFiles: [],
        isGHGInventory: true,
        isSBTiTarget: true,
        isIsoOrg: false,
        isIsoPCF: false,
        isEPD: false,
        isCBAM: false,
        isSustainabilityReport: false,
        isOthers: false,
        GHGInventoryFiles: [],
        ISOOrgFiles: [],
        ISOPCFFiles: [],
        EPDFiles: [],
        CBAMFiles: [],
        SustainabilityReportFiles: [],
        OthersFiles: [],
        SrReportFiles: [],
        IsoReportFiles: [],
        type: "company",
        isParisAggrement: true,
        SBTiTemperature: "56",
        emiReductionYear: 2024,
        emiReductionRatio: "56",
        regressionModel: "56",
        baselineYear: 2024,
        targetYear: 2024,
      },
    },
  },
  {
    suggestionCompany:
      "Temperature Alignment, SBTi, Net Zero, GHG (both company and ind average)",
    data: {
      companyProfile: {
        // "suggestCompanyType": "Suggestions",
        suggestCompanyType:
          "Temperature Alignment, SBTi, Net Zero, GHG (both company and ind average)",
        // "industry" : "Coal",
        // "companyType": "HQ",
        // "HQCountry": "Taiwan",
        // "SICCode": "2345",
        SBTiTargetFiles: [],
        isGHGInventory: false,
        isSBTiTarget: true,
        isIsoOrg: false,
        isIsoPCF: false,
        isEPD: false,
        isCBAM: false,
        isSustainabilityReport: false,
        isOthers: false,
        GHGInventoryFiles: [],
        ISOOrgFiles: [],
        ISOPCFFiles: [],
        EPDFiles: [],
        CBAMFiles: [],
        SustainabilityReportFiles: [],
        OthersFiles: [],
        SrReportFiles: [],
        IsoReportFiles: [],
        type: "company",
        isParisAggrement: true,
        SBTiTemperature: "43",
        emiReductionYear: 2024,
        emiReductionRatio: "43",
        regressionModel: "43",
        baselineYear: 2024,
        targetYear: 2024,
      },
    },
  },
];

export const CARBON_NEUTRAL_DUMMY = [
  {
    _id: 123,
    assetType: "Vapor Chiller",
    index: 1,
    energySystem: "Cooling",
    assetInfo: {
      capacity: 10,
      noOfUnit: 10,
      opHr: 1,
      coefficient: 10,
      efficiency: 10,
      input: "Fuel",
      output: "Heat",
      configuration: false,
      fuelInfo: {
        fuelName: "Fuel Name",
        LHV: 10,
        consumptionData: 10,
        isBiomass: false,
        co2Factor: 12,
        ch4Factor: 10,
        n2oFactor: 10,
      },
    },
    mainEquipmentCost: 3284,
    isSelected: false,
    createdDate: "2023-01-25T04:11:54.202+00:00",
  },
  {
    _id: 1,
    assetType: "Steam Turbine",
    index: 1,
    energySystem: "Electricity",
    assetInfo: {
      capacity: 10,
      noOfUnit: 10,
      opHr: 1,
      coefficient: 10,
      efficiency: 10,
      input: "Fuel",
      output: "Heat",
      configuration: false,
      fuelInfo: {
        fuelName: "Fuel Name",
        LHV: 10,
        consumptionData: 10,
        isBiomass: false,
        co2Factor: 12,
        ch4Factor: 10,
        n2oFactor: 10,
      },
    },
    mainEquipmentCost: 384,
    isSelected: false,
    createdDate: "2023-03-25T04:11:54.202+00:00",
  },
  {
    _id: 2,
    assetType: "Steam Turbine",
    index: 2,
    energySystem: "Electricity",
    assetInfo: {
      capacity: 10,
      noOfUnit: 10,
      opHr: 1,
      coefficient: 10,
      efficiency: 10,
      input: "Fuel",
      output: "Heat",
      configuration: true,
      fuelInfo: {
        fuelName: "Fuel Name",
        LHV: 10,
        consumptionData: 10,
        isBiomass: false,
        co2Factor: 12,
        ch4Factor: 10,
        n2oFactor: 10,
      },
    },
    isSelected: false,
    mainEquipmentCost: 284,

    createdDate: "2024-03-25T04:11:54.202+00:00",
  },
  {
    _id: 13,
    assetType: "Absorption Chiller",
    index: 1,
    energySystem: "Cooling",
    assetInfo: {
      capacity: 10,
      noOfUnit: 10,
      opHr: 1,
      coefficient: 10,
      efficiency: 10,
      input: "Fuel",
      output: "Heat",
      configuration: false,
      fuelInfo: {
        fuelName: "Fuel Name",
        LHV: 10,
        consumptionData: 10,
        isBiomass: false,
        co2Factor: 12,
        ch4Factor: 10,
        n2oFactor: 10,
      },
    },
    isSelected: false,
    mainEquipmentCost: 345,

    createdDate: "2024-03-26T04:11:54.202+00:00",
  },
  {
    _id: 3,
    assetType: "Steam Turbine",
    index: 3,
    energySystem: "Electricity",
    assetInfo: {
      capacity: 10,
      noOfUnit: 10,
      opHr: 1,
      coefficient: 10,
      efficiency: 10,
      input: "Fuel",
      output: "Heat",
      configuration: true,
      fuelInfo: {
        fuelName: "Fuel Name",
        LHV: 10,
        consumptionData: 10,
        isBiomass: false,
        co2Factor: 12,
        ch4Factor: 10,
        n2oFactor: 10,
      },
    },
    isSelected: false,
    mainEquipmentCost: 123,

    createdDate: "2024-04-26T04:11:54.202+00:00",
  },
  {
    _id: 15,
    assetType: "Vapor Chiller",
    index: 1,
    energySystem: "Cooling",
    assetInfo: {
      capacity: 10,
      noOfUnit: 10,
      opHr: 1,
      coefficient: 10,
      efficiency: 10,
      input: "Fuel",
      output: "Heat",
      configuration: false,
      fuelInfo: {
        fuelName: "Fuel Name",
        LHV: 10,
        consumptionData: 10,
        isBiomass: false,
        co2Factor: 12,
        ch4Factor: 10,
        n2oFactor: 10,
      },
    },
    isSelected: false,
    mainEquipmentCost: 643,

    createdDate: "2024-05-26T04:11:54.202+00:00",
  },
  {
    _id: 4,
    assetType: "Solar PV",
    index: 1,
    energySystem: "Electricity",
    assetInfo: {
      capacity: 10,
      noOfUnit: 10,
      opHr: 1,
      coefficient: 10,
      efficiency: 10,
      input: "external",
      output: "Heat",
      configuration: false,
    },
    externalEnergyResource: {
      type: "Other",
      name: "Test Resource",
      consumptionData: 10,
      emissionFactor: 10,
    },
    isSelected: false,
    mainEquipmentCost: 432,

    createdDate: "2023-05-26T04:11:54.202+00:00",
  },
  {
    _id: 5,
    assetType: "Boiler",
    index: 2,
    energySystem: "Heat",
    assetInfo: {
      capacity: 10,
      noOfUnit: 10,
      opHr: 1,
      coefficient: 10,
      efficiency: 10,
      input: "external",
      output: "Heat",
      configuration: true,
    },
    externalEnergyResource: {
      type: "District Cooling",
      consumptionData: 10,
      emissionFactor: 10,
    },
    isSelected: true,
    mainEquipmentCost: 987,

    createdDate: "2023-07-26T04:11:54.202+00:00",
  },
  {
    _id: 6,
    assetType: "Heat Pump",
    index: 3,
    energySystem: "Heat",
    assetInfo: {
      capacity: 10,
      noOfUnit: 10,
      opHr: 1,
      coefficient: 10,
      efficiency: 10,
      input: "external",
      output: "Heat",
      configuration: true,
    },
    externalEnergyResource: {
      type: "District Heat",
      consumptionData: 10,
      emissionFactor: 10,
    },
    isSelected: true,
    mainEquipmentCost: 3876,

    createdDate: "2023-07-24T04:11:54.202+00:00",
  },
  {
    _id: 7,
    assetType: "Boiler",
    index: 1,
    energySystem: "Heat",
    assetInfo: {
      capacity: 10,
      noOfUnit: 10,
      opHr: 1,
      coefficient: 10,
      efficiency: 10,
      input: "external",
      output: "Heat",
      configuration: false,
    },
    externalEnergyResource: {
      type: "Grid",
      consumptionData: 10,
      emissionFactor: 10,
    },
    isSelected: true,
    mainEquipmentCost: 2421,

    createdDate: "2023-04-24T04:11:54.202+00:00",
  },
  {
    _id: 8,
    assetType: "Heat Pump",
    index: 2,
    energySystem: "Heat",
    assetInfo: {
      capacity: 10,
      noOfUnit: 10,
      opHr: 1,
      coefficient: 10,
      efficiency: 10,
      input: "External Energy Resource",
      output: "Heat",
      configuration: false,
    },
    externalEnergyResource: {
      type: "Grid",
      consumptionData: 10,
      emissionFactor: 10,
    },
    isSelected: true,
    mainEquipmentCost: 2123,

    createdDate: "2023-03-24T04:11:54.202+00:00",
  },
];
